import { useMutation, useQueryClient } from "@tanstack/react-query";
import { BookingService } from "@/services/BookingService";

type Result = { success: boolean; cancelledCount: number; wasChargedOnCancel: boolean; message: string };

export function useCancelBookingFromDate(bookingId: string) {
  const queryClient = useQueryClient();
  const bookingService = new BookingService();
  return useMutation<Result, Error, { fromDate: string; waive?: boolean; waiveNote?: string }>({
    mutationFn: ({ fromDate, waive, waiveNote }) => bookingService.cancelBookingFromDate(bookingId, fromDate, { waive, waiveNote }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bookings"] });
      queryClient.invalidateQueries({ queryKey: ["booking", bookingId] });
      queryClient.invalidateQueries({ queryKey: ["booking-counts"] });
      queryClient.invalidateQueries({ queryKey: ["member-bookings"] });
    },
  });
}
